/** Autenticación de socios y visitantes (app) — contracts.md §2. */
import { z } from "zod";
import { DOC_TYPES, PERSON_KINDS, PLATFORMS } from "../enums.js";
import { objectId } from "./base.js";
import { email, password } from "./auth.js";
/**
 * Alta digital (D4) — cuerpo MÍNIMO que crea la ficha y devuelve sesión.
 * El wizard completo (declaración de condición física, consentimientos versionados,
 * pago online) lo termina el módulo Socios: lo que falte queda en `incompleteFlags`
 * (RN-SOC-07) y la identidad se verifica en la primera visita presencial (D4).
 */
export const appRegisterBody = z.object({
    identity: z.object({
        docType: z.enum(DOC_TYPES).default("dni"),
        docNumber: z.string().trim().min(5).max(30),
    }),
    firstName: z.string().trim().min(1).max(80),
    lastName: z.string().trim().min(1).max(80),
    birthDate: z.coerce.date(),
    email,
    phone: z.string().trim().min(6).max(40),
    password,
    branchOfOriginId: objectId,
});
export const appPerson = z.object({
    kind: z.enum(PERSON_KINDS),
    id: objectId,
    firstName: z.string(),
    lastName: z.string(),
    memberNumber: z.number().int().optional(),
    platform: z.enum(PLATFORMS).optional(),
    status: z.string(),
});
export const appTokenPair = z.object({
    accessToken: z.string(),
    refreshToken: z.string(),
});
export const appAuthResponse = appTokenPair.extend({ person: appPerson });
export const appLoginBody = z.object({ email, password: z.string().min(1).max(200) });
/** Primer acceso del socio migrado o dado de alta en mostrador. */
export const appActivateBody = z.object({ token: z.string().min(1), password });
export const appOtpRequestBody = z.object({ email });
export const appOtpVerifyBody = z.object({
    email,
    code: z.string().regex(/^\d{6}$/),
    newPassword: password.optional(),
});
export const appRefreshBody = z.object({ refreshToken: z.string().min(1) });
/**
 * «Cerrar sesión» de la app. El refresh es la credencial (el access token puede estar
 * vencido); el token de push del teléfono viaja para que ese dispositivo deje de recibir
 * los avisos de la cuenta que se cerró.
 */
export const appLogoutBody = z.object({
    refreshToken: z.string().min(1),
    expoPushToken: z.string().trim().min(10).max(200).optional(),
});
export const appMeResponse = z.object({
    person: appPerson,
    branchOfOriginId: objectId.nullable(),
});
export const pushTokenBody = z.object({
    expoPushToken: z.string().trim().min(10).max(200),
});
/** Semilla TOTP del carnet (RN-ACC-06). Cifrada en reposo. */
/**
 * Semilla del carnet (RN-ACC-06). `digits` y `algorithm` viajan porque el TOTP se genera
 * **offline** en el teléfono y tiene que coincidir bit a bit con lo que valida el punto de
 * acceso. La semilla va en **Base32 RFC 4648 sin padding**.
 */
export const qrSeedResponse = z.object({
    seed: z.string(),
    ttlSec: z.number().int(),
    digits: z.number().int().min(6).max(8),
    algorithm: z.literal("SHA1"),
    rotatedAt: z.coerce.date().nullable(),
});
export const appAccessTokenClaims = z.object({
    sub: objectId,
    kind: z.enum(["member", "visitor"]),
    sid: z.string(),
});
//# sourceMappingURL=auth-app.js.map